<template>
  <div ref="returnTop" class="con" style="overflow-x: hidden">
    <div class="flex-col header">
      <div class="flex-row justify-between items-center group">
        <div
          class="flex-row space-x-18"
          style="display: flex; align-items: center"
        >
          <div class="section"></div>
          <div class="flex-col items-start space-y-12">
            <span class="font_1 text">吉泰物流</span>
            <span class="font_3 text_8">让天下没有难运的车</span>
          </div>
        </div>
        <div class="flex-row group_2 space-x-48">
          <span
            class="font_2 text_2 point"
            @click="homeTab = 0"
            :style="{ color: homeTab == 0 ? '#3c9cff' : '#000' }"
            >首页</span
          >
          <span
            class="font_2 text_3 point"
            @click="homeTab = 1"
            :style="{ color: homeTab == 1 ? '#3c9cff' : '#000' }"
            >产品服务</span
          >
          <span
            class="font_2 text_4 point"
            @click="homeTab = 2"
            :style="{ color: homeTab == 2 ? '#3c9cff' : '#000' }"
            >快速运车</span
          >
          <span
            class="font_2 text_5 point"
            @click="homeTab = 4"
            :style="{ color: homeTab == 4 ? '#3c9cff' : '#000' }"
            >加盟合作</span
          >
          <span
            class="font_2 text_6 point"
            @click="homeTab = 3"
            :style="{ color: homeTab == 3 ? '#3c9cff' : '#000' }"
            >新闻资讯</span
          >
          <span
            class="font_2 text_7 point"
            @click="homeTab = 5"
            :style="{ color: homeTab == 5 ? '#3c9cff' : '#000' }"
            >关于我们</span
          >
        </div>
      </div>
      <!-- <div class="self-end section_2"></div> -->
    </div>
    <div v-show="homeTab == 0">
      <div class="flex-col flex-auto group_3">
        <div class="flex-col justify-start section_3">
          <div class="flex-col section_4 space-y-10">
            <div class="flex-col items-start group_4 space-y-10">
              <span class="font_4">打造汽车行业综合服务平台</span>
              <span class="font_4"
                >为汽车交易、流通、后市场、提供服务及解决方案</span
              >
            </div>
            <div class="flex-col justify-start self-start text-wrapper"></div>
          </div>
        </div>
        <span class="self-center font_6 text_10">优质服务</span>
        <span class="self-center font_7 text_11"
          >为客户提供高效率、高标准、严要求、有保障的运输服务。</span
        >
        <div class="flex-col group_5 view">
          <div class="flex-row space-x-24">
            <img
              class="equal-division-item image"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570434771865574.png"
            />
            <img
              class="equal-division-item image_2"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570435631975129.png"
            />
            <img
              class="equal-division-item image_3"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570436367516107.png"
            />
          </div>
          <div class="flex-row space-x-24">
            <div class="flex-col section_5">
              <span class="self-start font_1">专业验车</span>
              <div class="self-start section_7"></div>
              <div class="flex-col group_6 space-y-4">
                <div class="font_8" style="text-align: left">
                  团队经验丰富,规范的操作流程,省心省事。
                  <br />
                </div>
              </div>
            </div>
            <div class="flex-col section_5">
              <span class="self-start font_1">上门提送</span>
              <div class="self-start section_7"></div>
              <div class="flex-col group_6 view_2 space-y-4">
                <span class="font_8" style="text-align: left">
                  全方位人性化服务,满足不同地区客户需求。
                  <br />
                </span>
              </div>
            </div>
            <div class="flex-col section_6">
              <span class="self-start font_1">车辆检修</span>
              <div class="self-start section_7"></div>
              <div class="flex-col group_6 space-y-4">
                <span class="font_8">
                  拥有具有丰富的理论知识及实践操作经验的管理专业
                  <br />
                </span>
                <span class="self-start font_8">人才。</span>
              </div>
            </div>
          </div>
          <div class="flex-row justify-center relative group_7">
            <img
              class="equal-division-item pos"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570432835404847.png"
            />
            <img
              class="equal-division-item"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16923381879734477034.png"
            />
          </div>
          <div class="flex-row space-x-24">
            <div class="flex-col section_8">
              <span class="self-start font_1">全险保障</span>
              <div class="self-start section_7"></div>
              <div class="flex-col group_6 space-y-4">
                <span class="font_8" style="text-align: left">
                  赠送20万车辆运输险，安全无忧运车。
                  <br />
                </span>
              </div>
            </div>
            <div class="flex-col section_8">
              <span class="self-start font_1">高效运输</span>
              <div class="self-start section_7"></div>
              <div class="flex-col group_6 space-y-4">
                <span class="font_8" style="text-align: left">
                  拥有专业司机和专业人员制定路线,用最高的效率完成运输。
                  <br />
                </span>
                <span class="self-start font_8"></span>
              </div>
            </div>
            <div class="flex-col section_9">
              <img
                class="shrink-0 self-center equal-division-item image_4"
                src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16901622831610736610.png"
              />
              <span class="self-start font_1 text_12">24h客服</span>
              <div
                class="self-start section_7"
                style="margin-left: 0.094rem"
              ></div>
              <div class="flex-col self-center group_8 space-y-4">
                <div class="font_8" style="text-align: left">
                  24小时人工客服,在途清晰可查。坚持信誉第一,客户至上的服务宗旨。
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-col group_9">
          <div class="flex-col section_10 space-y-31">
            <span class="self-center font_6">产品服务</span>
            <span class="self-center font_7"
              >一切从为客户提供最优运力解决方案出发</span
            >
            <div class="flex-row items-start space-x-58">
              <div class="flex-col group_10">
                <!-- <div class="flex-row items-center space-x-18">
                <span class="font_9 text_13">汽车运输</span>
                <div class="shrink-0 section_11"></div>
              </div> -->
                <div class="flex-row items-center space-x-18">
                  <div class="flex-col space-y-46">
                    <span
                      class="self-center font_9 text_15 point"
                      :style="{ color: active == 0 ? '#2a82e4' : '' }"
                      @click="active = 0"
                      >汽车运输</span
                    >
                    <div class="flex-col space-y-46">
                      <span
                        class="self-center font_9 text_16 point"
                        :style="{ color: active == 1 ? '#2a82e4' : '' }"
                        @click="active = 1"
                        >多式联运</span
                      >
                      <span
                        class="self-center font_9 text_17 point"
                        :style="{ color: active == 2 ? '#2a82e4' : '' }"
                        @click="active = 2"
                        >仓储服务</span
                      >
                      <div class="flex-col items-center space-y-44">
                        <span class="font_9 text_18"></span>
                        <span class="font_9 text_19"></span>
                        <span class="font_9 text_20"></span>
                      </div>
                    </div>
                  </div>
                  <div class="section_13"></div>
                </div>
              </div>
              <div
                class="flex-col justify-start items-start flex-auto relative"
              >
                <img class="image_5" :src="object[active].img" />
                <div class="flex-col section_12 pos_2">
                  <div class="flex-col group_11 space-y-26">
                    <span class="self-start text_14">{{
                      object[active].title
                    }}</span>
                    <div
                      class="flex-col items-start group_12 space-y-4"
                      style="width: 2.14rem"
                    >
                      <span class="font_10" style="text-align: left">{{
                        object[active].msg
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="flex-col justify-start items-center self-start text-wrapper_2"
                  >
                    <span class="font_5 cursor" @click="homeTab = 1"
                      >查看详情</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-row items-center space-x-61">
            <img
              class="image_6"
              src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570433801513190.png"
            />
            <div class="flex-col">
              <span class="self-start text_21">行业优势</span>
              <span class="self-start font_3 text_22"
                >全国195业务网点24小时提供服务</span
              >
              <span class="self-start font_1 text_23">选择我们的五个理由</span>
              <div class="flex-row items-center group_13 space-x-6">
                <div class="shrink-0 section_14"></div>
                <span class="font_11">覆盖中国1-4线城市,承运线路2000+。</span>
              </div>
              <div class="flex-row items-center group_14 space-x-6">
                <div class="shrink-0 section_14"></div>
                <span class="font_11">赠送20万车辆运输险,安全无忧运车。</span>
              </div>
              <div class="flex-row items-center group_15 space-x-6">
                <div class="shrink-0 section_14"></div>
                <span class="font_11">24小时人工客服,在途清晰可查。</span>
              </div>
              <div class="flex-row items-center group_16 space-x-6">
                <div class="shrink-0 section_14"></div>
                <span class="font_11">全国运力10000+,时效有保障。</span>
              </div>
              <div class="flex-row items-center group_17 space-x-6">
                <div class="shrink-0 section_14"></div>
                <span class="font_11">20公里以内免费提送车。</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-col group_5 view_3 space-y-34">
          <div class="flex-col items-center space-y-30">
            <span class="font_6 text_24">新闻资讯</span>
            <span class="font_7">聚焦行业资讯,标准规范。</span>
          </div>
          <div class="flex-col">
            <div class="flex-row space-x-24">
              <img
                class="equal-division-item image_7"
                src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16914520143184999980.png"
              />
              <img
                class="equal-division-item image_8"
                src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16914520237817739506.png"
              />
              <img
                class="equal-division-item image_9"
                src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16914520143383092991.png"
              />
            </div>
            <div class="flex-row space-x-24">
              <div
                class="flex-col equal-division-item_2 space-y-44"
                @click="myFunc(2)"
              >
                <div class="flex-col">
                  <span class="self-start font_1">汽车托运行业发展前景</span>
                  <div class="self-start section_7"></div>
                  <div class="flex-col group_18 space-y-4">
                    <span
                      class="font_8"
                      style="
                        text-align: left;
                        white-space: normal;
                        word-break: break-all;
                        word-wrap: break-word;
                      "
                    >
                      近年来,随着人们生活水平的提高和汽车消费的普及,汽车托运行业也得到了迅速发展。
                    </span>
                  </div>
                </div>
                <span class="self-start font_12 cursor">查看详情</span>
              </div>
              <div
                class="flex-col equal-division-item_2 space-y-44"
                @click="myFunc(1)"
              >
                <div class="flex-col">
                  <span
                    class="self-start font_1"
                    style="display: flex; text-align: left"
                    >经济循环畅通改善物流业支撑国民经济</span
                  >
                  <div class="self-start section_7"></div>
                  <div class="flex-col group_18 space-y-4">
                    <span
                      class="font_8"
                      style="
                        text-align: left;
                        word-wrap: break-word;
                        word-break: break-all;
                        display: block;
                      "
                    >
                      中国物流与采购联合会公布:今年上半年,全国社会物流总额为160.6万亿元,同比增长4.8%,物流需求整体呈现持续回升态势。
                    </span>
                  </div>
                </div>
                <span class="self-start font_12 cursor" style="margin-top: 2em"
                  >查看详情</span
                >
              </div>
              <div
                class="flex-col equal-division-item_2 space-y-44"
                @click="myFunc(3)"
              >
                <div class="flex-col">
                  <span class="self-start font_1"
                    >民营物流企业发展作用突出</span
                  >
                  <div class="self-start section_7"></div>
                  <div class="flex-col group_18 space-y-4">
                    <span
                      class="font_8"
                      style="
                        text-align: left;
                        word-wrap: break-word;
                        word-break: break-all;
                        display: block;
                      "
                    >
                      中国物流与采购联合会昨天（8月3日）发布了2023年度中国物流企业50强。
                    </span>
                  </div>
                </div>
                <span class="self-start font_12 cursor">查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <About v-show="homeTab == 5"></About>
    <Add v-show="homeTab == 4"></Add>
    <Quick v-show="homeTab == 2"></Quick>
    <Serve v-show="homeTab == 1"></Serve>
    <News ref="news" v-if="homeTab == 3"></News>
    <Bottom :style="{ marginTop: homeTab != 2 ? '0.82rem' : '0' }"></Bottom>
    <!-- <div class="flex-col section_15">
      <div class="self-center section_16"></div>
      <span class="self-center font_1 text_31">长春市吉泰物流有限公司</span>
      <div class="flex-row justify-center items-center group_20 space-x-33">
        <div class="section_17"></div>
        <span class="font_13 text_32">信赖源自真诚,服务赢得未来</span>
        <div class="section_17"></div>
      </div>
      <span class="self-center font_13 text_33"
        >京公网安备号11010802020287京ICP备110187762号</span
      >
      <span class="self-center font_10 text_34"> @吉泰物流 版权所有 </span>
    </div> -->
  </div>
</template>

<script>
import About from "./about.vue";
import Serve from "./serve.vue";
import Add from "./add.vue";
import Quick from "./quick.vue";
import Bottom from "./bottom.vue";
import News from "./news.vue";
export default {
  name: "base",
  components: { About, Add, Quick, Serve, News, Bottom },
  data() {
    return {
      homeTab: 0,
      active: 0,
      object: [
        {
          img: "https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570432024208480.png",
          title: "运输覆盖范围广",
          msg: "业务覆盖二手车、私家车、高端车、电商平台及周边衍生运输业务,全国195个业务网点,承运线路2000+",
        },
        {
          img: "https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16923477377262169024.png",
          title: "运输资源丰富",
          msg: "因运输行业特殊时期的运力紧张,而导致的车辆滞留、爆库、时效等问题,为客户提供了专业的公、铁、水联运服务,给与客户提供更多更好的服务选择。",
        },
        {
          img: "https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570505547306835.png",
          title: "仓储网点辐射全国",
          msg: "全国仓储总面积达100万平方米,主交通枢纽区建立了10个大型分拨仓,以及多个场地仓、前置仓,公司拥有专业的仓储管理团队,以及自主研发的完善管理系统。",
        },
      ],
    };
  },
  watch: {
    homeTab() {
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }, 100);
      });
    },
  },
  methods: {
    myFunc(sort) {
      this.homeTab = 3;
      this.$nextTick(() => {
        this.$refs.news.sort = sort;
      });
    },
  },
};
</script> 

<style scoped>
.cursor {
  cursor: pointer;
}

html {
  font-size: 16px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.justify-evenly {
  justify-content: space-evenly;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.items-baseline {
  align-items: baseline;
}

.items-stretch {
  align-items: stretch;
}

.self-start {
  align-self: flex-start;
}

.self-end {
  align-self: flex-end;
}

.self-center {
  align-self: center;
}

.self-baseline {
  align-self: baseline;
}

.self-stretch {
  align-self: stretch;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-auto {
  flex: 1 1 auto;
}

.grow {
  flex-grow: 1;
}

.grow-0 {
  flex-grow: 0;
}

.shrink {
  flex-shrink: 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.relative {
  position: relative;
}

.header {
  padding: 0 0.2rem 0.055rem;
  height: 0.32rem;
  position: sticky;
  top: 0;
  left: 0;
  background: #ffffff;
  z-index: 99;
  border-bottom: 0.001rem solid #7a7a7a;
}
.group {
  padding: 0.063rem 0 0.0078rem;
}
.space-x-18 > *:not(:first-child) {
  margin-left: 0.07rem;
}
.section {
  background: url("https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570419959233720.png");
  width: 0.23rem;
  height: 0.14rem;
  margin-top: 0.015rem;
  background-size: 100% 100%;
}
.space-y-12 > *:not(:first-child) {
  margin-top: 0.047rem;
}
.font_1 {
  font-size: 0.082rem;
  font-family: PingFang;
  line-height: 0.076rem;
  font-weight: 700;
  color: #000000;
}
.text {
  font-size: 0.078rem;
  font-weight: 800;
  line-height: 0.072rem;
}
.font_3 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.055rem;
  color: #dbcdcc;
}
.text_8 {
  color: #7d7070;
  font-size: 0.063rem;
  line-height: 0.059rem;
}
.group_2 {
  margin-right: 0.17rem;
}
.space-x-48 > *:not(:first-child) {
  margin-left: 0.19rem;
}
.font_2 {
  font-size: 0.07rem;
  font-family: SourceHanSansCN;
  line-height: 0.07rem;
  color: #000000;
}
.text_2 {
  color: #2a82e4;
  line-height: 0.066rem;
}
.text_3 {
  line-height: 0.066rem;
}
.text_4 {
  line-height: 0.066rem;
}
.text_5 {
  line-height: 0.066rem;
}
.text_6 {
  line-height: 0.066rem;
}
.text_7 {
  line-height: 0.066rem;
}
.section_2 {
  margin-right: 2.54rem;
  background-color: #2a82e4;
  border-radius: 0.039rem;
  width: 0.14rem;
  height: 0.012rem;
}
.space-x-18 > *:not(:first-child) {
  margin-left: 0.07rem;
}
.font_1 {
  font-size: 0.082rem;
  font-family: PingFang;
  line-height: 0.076rem;
  font-weight: 700;
  color: #000000;
}
.font_3 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.055rem;
  color: #7d7070;
}
.group_3 {
  overflow-y: auto;
}
.section_3 {
  background-image: url("https://official-1317286948.cos.ap-beijing.myqcloud.com/nav1.webp"),
    url("https://official-1317286948.cos.ap-beijing.myqcloud.com/home-head-1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 2.09rem;
}
.section_4 {
  padding: 0 1.24rem 0.46rem;
  background-image: linear-gradient(
    180deg,
    #091625f7 -8.1%,
    #0b1726 6.8%,
    #28263640 100%
  );
}
.group_4 {
  padding: 0.66rem 0 0.28rem;
}
.space-y-10 > *:not(:first-child) {
  margin-top: 0.039rem;
}
.font_4 {
  font-size: 0.19rem;
  font-family: PingFang;
  line-height: 0.23rem;
  font-weight: 800;
  color: #ffffff;
}
.text-wrapper {
  margin-left: 0.0078rem;
  padding: 0.047rem 0;
  background-color: #ffffff;
}
.font_5 {
  font-size: 0.07rem;
  font-family: PingFang;
  line-height: 0.064rem;
  color: #ffffff;
}
.text_9 {
  margin-left: 0.063rem;
  margin-right: 0.047rem;
  color: #2a82e4;
}
.font_6 {
  font-size: 0.12rem;
  font-family: PingFang;
  line-height: 0.11rem;
  font-weight: 700;
  color: #000000;
}
.text_10 {
  margin-top: 0.41rem;
}
.font_7 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.055rem;
  color: #7a7a7a;
}
.text_11 {
  margin-top: 0.13rem;
}
.group_5 {
  padding: 0 1.25rem;
}
.view {
  margin-top: 0.16rem;
}
.space-x-24 > *:not(:first-child) {
  margin-left: 0.094rem;
}
.equal-division-item {
  width: 1.6rem;
  height: 0.54rem;
}
.image {
  flex: 1 1 1.6rem;
}
.image_2 {
  flex: 1 1 1.6rem;
}
.image_3 {
  flex: 1 1 1.6rem;
}
.section_5 {
  flex: 1 1 1.6rem;
  padding: 0.094rem 0.094rem 0;
  filter: drop-shadow(0px 0.0078rem 0.02rem #4d5b701a);
  background-color: #ffffff;
  height: 0.6rem;
}
.section_7 {
  margin-top: 0.055rem;
  background-color: #2a82e4;
  border-radius: 0.039rem;
  width: 0.16rem;
  height: 0.012rem;
}
.group_6 {
  margin-right: 0.031rem;
  padding: 0.078rem 0 0.13rem;
}
.group_6 {
  margin-right: 0.031rem;
  padding: 0.078rem 0 0.13rem;
}
.font_8 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.07rem;
  color: #766968;
}
.view_2 {
  margin-right: 0.039rem;
}
.section_6 {
  padding: 0.094rem 0.094rem 0;
  flex: 1 1 1.6rem;
  filter: drop-shadow(0px 0.0078rem 0.02rem #4d5b701a);
  background-color: #ffffff;
  height: 0.6rem;
}
.group_7 {
  margin-top: 0.098rem;
}
.pos {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.section_8 {
  flex: 1 1 1.6rem;
  padding: 0.094rem 0.098rem 0;
  filter: drop-shadow(0px 0.0078rem 0.02rem #4d5b701a);
  background-color: #ffffff;
  height: 0.6rem;
}
.section_9 {
  flex: 1 1 1.6rem;
  filter: drop-shadow(0px 0.0078rem 0.02rem #4d5b701a);
  background-color: #ffffff;
  height: 0.6rem;
}
.image_4 {
  margin-top: -0.53rem;
}
.text_12 {
  margin-left: 0.094rem;
  margin-top: 0.094rem;
}
.group_8 {
  padding: 0.078rem 0 0.13rem;
  width: 1.37rem;
}
.group_9 {
  margin-top: 0.32rem;
}
.section_10 {
  padding: 0.41rem 1.26rem 0.41rem 1.35rem;
  background-color: #f0f0f0;
}
.space-y-31 > *:not(:first-child) {
  margin-top: 0.12rem;
}
.space-x-58 > *:not(:first-child) {
  margin-left: 0.23rem;
}
.group_10 {
  margin-top: 0.055rem;
}
.font_9 {
  font-size: 0.07rem;
  font-family: PingFang;
  line-height: 0.07rem;
  font-weight: 700;
  color: #383838;
}
.text_13 {
  margin-left: 0.21rem;
  color: #2a82e4;
  line-height: 0.066rem;
}
.section_11 {
  background-color: #2a82e4;
  border-radius: 0.039rem;
  width: 0.0078rem;
  height: 0.23rem;
}
.space-y-46 > *:not(:first-child) {
  margin-top: 0.18rem;
}
.text_15 {
  line-height: 0.066rem;
}
.text_16 {
  line-height: 0.066rem;
}
.text_17 {
  line-height: 0.066rem;
}
.text_18 {
  line-height: 0.066rem;
}
.text_19 {
  line-height: 0.066rem;
}
.text_20 {
  line-height: 0.066rem;
}
.section_13 {
  background-color: #2a82e447;
  width: 0.002rem;
  height: 1.43rem;
}
.image_5 {
  width: 2.54rem;
  height: 1.34rem;
}
.section_12 {
  padding: 0 0.086rem 0.094rem;
  background-color: #2a82e4d4;
  border-radius: 0.02rem;
}
.pos_2 {
  position: absolute;
  right: 0;
  top: 0.24rem;
}
.group_11 {
  padding: 0.12rem 0 0.16rem;
}
.space-y-26 > *:not(:first-child) {
  margin-top: 0.1rem;
}
.text_14 {
  color: #ffffff;
  font-size: 0.1rem;
  font-family: PingFang;
  line-height: 0.094rem;
}
.group_12 {
  padding: 0 0.0078rem;
}
.font_10 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.07rem;
  color: #ffffff;
}
.text-wrapper_2 {
  padding: 0.047rem 0;
  border-radius: 0.02rem;
  width: 0.68rem;
  border: solid 0.0039rem #ffffff;
}
.space-x-61 > *:not(:first-child) {
  margin-left: 0.24rem;
}
.image_6 {
  width: 3.51rem;
  height: 1.91rem;
}
.text_21 {
  margin-left: 0.016rem;
  color: #000000;
  font-size: 0.13rem;
  font-family: PingFang;
  font-weight: 700;
  line-height: 0.12rem;
}
.text_22 {
  margin-left: 0.016rem;
  margin-top: 0.15rem;
  color: #383838;
}
.text_23 {
  margin-top: 0.24rem;
  font-size: 0.086rem;
  line-height: 0.08rem;
}
.group_13 {
  margin-top: 0.2rem;
}
.section_14 {
  background-color: #000000;
  border-radius: 50%;
  width: 0.012rem;
  height: 0.012rem;
}
.font_11 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.07rem;
  color: #383838;
}
.group_14 {
  margin-top: 0.11rem;
}
.group_15 {
  margin-top: 0.11rem;
}
.group_16 {
  margin-top: 0.11rem;
}
.group_17 {
  margin-top: 0.1rem;
}
.space-x-6 > *:not(:first-child) {
  margin-left: 0.023rem;
}
.view_3 {
  margin-top: 0.41rem;
}
.space-y-34 > *:not(:first-child) {
  margin-top: 0.13rem;
}
.space-y-30 > *:not(:first-child) {
  margin-top: 0.12rem;
}
.text_24 {
  line-height: 0.11rem;
}
.image_7 {
  flex: 1 1 1.6rem;
}
.image_8 {
  flex: 1 1 1.6rem;
}
.image_9 {
  flex: 1 1 1.6rem;
}
.equal-division-item_2 {
  flex: 1 1 1.6rem;
  padding: 0.094rem;
  filter: drop-shadow(0px 0.0078rem 0.02rem #4d5b701a);
  background-color: #ffffff;
  margin-bottom: 0.01rem;
  height: 0.78rem;
}
.space-y-44 > *:not(:first-child) {
  margin-top: 0.17rem;
}
.group_18 {
  /* margin-right: 0.039rem; */
  padding-top: 0.078rem;
}
.space-y-4 > *:not(:first-child) {
  margin-top: 0.016rem;
}
.font_12 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.055rem;
  color: #2a82e4;
}
.group_19 {
  margin-top: 0.76rem;
}
.space-y-42 > *:not(:first-child) {
  margin-top: 0.16rem;
}
.space-y-28 > *:not(:first-child) {
  margin-top: 0.11rem;
}
.text_25 {
  line-height: 0.059rem;
}
.space-y-43 > *:not(:first-child) {
  margin-top: 0.17rem;
}
.space-x-20 > *:not(:first-child) {
  margin-left: 0.078rem;
}
.text-wrapper_3 {
  padding: 0.055rem 0;
  background-color: #fbf8f8;
  border-radius: 0.0078rem;
  width: 1.14rem;
  height: 0.17rem;
  border: solid 0.0039rem #e0d6d3;
}
.text_26 {
  margin-left: 0.055rem;
}
.text_27 {
  margin-left: 0.055rem;
}
.text_28 {
  margin-left: 0.063rem;
  line-height: 0.053rem;
}
.text_29 {
  margin-left: 0.055rem;
  line-height: 0.053rem;
}
.text-wrapper_4 {
  padding: 0.051rem 0 0.24rem;
  background-color: #fbf8f8;
  border-radius: 0.0078rem;
  width: 2.36rem;
  border: solid 0.0039rem #e0d6d3;
}
.text_30 {
  margin-left: 0.055rem;
}
.button {
  padding: 0.063rem 0 0.055rem;
  background-color: #2a82e4;
  width: 0.68rem;
}
.section_15 {
  margin-top: 0.39rem;
  padding: 0.2rem 1.24rem 0.21rem 1.27rem;
  background-color: #111111;
}
.section_16 {
  background: url("https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64bdd42dc430470012e64f87/16908570419978526459.png");
  width: 0.23rem;
  height: 0.14rem;
  background-size: 100% 100%;
}
.text_31 {
  margin-top: 0.039rem;
  color: #ffffff;
  font-size: 0.086rem;
  line-height: 0.08rem;
}
.group_20 {
  margin-top: 0.063rem;
}
.space-x-33 > *:not(:first-child) {
  margin-left: 0.13rem;
}
.section_17 {
  background-color: #ffffff;
  width: 1.98rem;
  height: 0.002rem;
}
.font_13 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.055rem;
  color: #ffffff;
}
.text_32 {
  line-height: 0.059rem;
}
.text_33 {
  margin-top: 0.07rem;
}
.text_34 {
  margin-top: 0.047rem;
  line-height: 0.061rem;
}

.point {
  cursor: pointer;
}

.point:hover {
  /* transform: scale(1.2); */
  text-decoration: underline;
  color: #3c9cff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/base.vue